import {SURVEY_REPORT_GET_RES, SURVEY_REPORT_GET_BACKUP,SURVEY_REPORT_LOAD} from '../actions';

export const getSurveyReportRespo = (res, demo) => ({
  type: SURVEY_REPORT_GET_RES,
  payload: {res, demo},
});

export const getSurveyReportBackup = (res, demo) => ({
  type: SURVEY_REPORT_GET_BACKUP,
  payload: {res, demo},
});
export const getSurveyReportLoad = (param) => ({
  type: SURVEY_REPORT_LOAD,
  payload: param,
});